/* @jsx h */
/* @jsxFrag Fragment */
/* eslint-disable react/react-in-jsx-scope */
// eslint-disable-next-line no-unused-vars
import { h, Fragment } from 'preact';
import c from './index.module.css';

const toClasses = props =>
  Object.keys(props)
    .map(prop => c[prop])
    .filter(prop => prop)
    .join(' ');

export const ArrowBox = ({ children, className, ...props }) => (
  <div className={`${className} ${c.arrowBox} ${toClasses(props)}`}>
    {children}
  </div>
);

export const classes = c;
